import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PagingModule } from '../../components/common/search/paging.module';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-tooltip';
import { BlockUIModule } from 'ng-block-ui';
import { DebounceModule } from '../../components/common/debounce/debounce.module';
import { MyDatePickerModule } from 'mydatepicker';
import { DeleteModalModule } from '../../components/common/deletemodal/delete.modal.module';
import { AuthModule } from '../../auth/auth.module';
import { CategoryTreeViewModule } from '../../components/common/category.tree.view/category.tree.view.module';
import { NoticesModule } from '../notices/notices.module';
import { CaMatchesComponent } from './my.matches.component';
import { CaResultsComponent } from './results.component';
import { CaSearchComponent } from './search.component';
import { HttpPrefixPipeModule } from '../../components/pipes/httpprefix.pipe/http.prefix.pipe.module';
import { B2BAngularMaterialModule } from '../../components/common/angular.material/b2b.angular.material.module';
import { DateRangeModule } from '../../components/common/date.range/date.range.module';
import { PrintContractAwardComponent } from './print.component';
import { CaBookmarkedComponent } from './bookmarked.component';
import { SafeHtmlPipeModule } from '../../components/pipes/safehtml.pipe/safe.html.pipe.module';
import { CaMatchesWithIdComponent } from './matches.with.id.component';
import { CaSharedBookmarkedComponent } from './shared.bookmarked.component';
import { CaBookmarksComponent } from './bookmarks.component';
import { CaSearchWithIdComponent } from './search.with.id.component';

@NgModule({
    declarations: [CaMatchesComponent, CaResultsComponent, CaSearchComponent, PrintContractAwardComponent, CaBookmarkedComponent,
        CaMatchesWithIdComponent, CaSharedBookmarkedComponent, CaBookmarksComponent, CaSearchWithIdComponent],
    imports: [
        BrowserModule, FormsModule, PagingModule, RouterModule, TooltipModule, DebounceModule, MyDatePickerModule,
        DeleteModalModule, AuthModule, CategoryTreeViewModule, BlockUIModule, NoticesModule, HttpPrefixPipeModule,
        B2BAngularMaterialModule, DateRangeModule, SafeHtmlPipeModule
    ],
    exports: [CaResultsComponent]
})

export class ContractAwardsModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/contract.awards/contract.awards.module.ts